<template>
    <div class="container">
        <CommonBreadcrumb class="bread_block" />

        <div>

            <CyoSteps v-if="moduleType === 'cyo'" :page="'diamond'" :moduleSubType="moduleSubType" />

            <CommonTitleDescription :title="tags.seo.value.page_title" :description="tags.seo.value.page_description" :total="resultCount" /> 

            <!-- <div v-if="$fetchState.pending" class="d-flex justify-content-center mt-5 pt-5 spinner"> -->
            <div v-if="false" class="d-flex justify-content-center mt-5 pt-5 spinner">

                <!-- <b-spinner label="Loading..."></b-spinner> -->
            </div>
            <div v-else>
                
                <DiamondFilter :togglers="togglers"/>
                <DiamondFilterPlate :togglers="togglers" :table="table"  @toggleTable="toggleTable"/>

                <div class="loader_box_mod" v-show="showSkeleton">
            <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
        </div>

                <CommonNoResultFound class="mt-1 pt-1" v-if="displayNoResults && table === 'result' " :type="'no_result'"  />

                <CommonNoResultFound class="mt-1 pt-1" v-if="hasError && table === 'result' " :type="'client_network_error'" />

                <!-- v-if single diamond listing -->
                <div v-if="moduleSubType !== 'earring'" class="listing-container-min-height" >

                    <div v-if="table === 'result'">
                        <DiamondTableBox v-if="isListviewActive"/>
                        <DiamondGridBox v-else />
                    </div>

                    <div v-else>
                        <DiamondCompareGrid v-if="!isListviewActive"/>
                        <DiamondCompareTable v-else />

                    </div>

                </div>
                <!-- pair diamond listing -->
                <div v-if="moduleSubType === 'earring'" class="listing-container-min-height" >

                    <div v-if="table === 'result'">
                        
                        <DiamondPairsDiamondBox />

                    </div>

                    <div v-else>
                        <DiamondPairDiamondCompareTable/>
                    </div>
                </div>
<!-- 
                <div class="loader_box_mod" v-show="showMoreSkeleton">
                    <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
                </div>
                <div v-if="getSettingListingNextPageUrl && table === 'result' " class="text-center mx-auto my-5 more_data_box">
                    <Button @click="showMore()">SHOW MORE</Button>
                </div> -->

                <div class="loader_box_mod" v-show="showMoreSkeleton">
                    <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
                </div>

                <div v-if="getSettingListingNextPageUrl && table === 'result' " class="text-center mx-auto my-5 more_data_box">
                    <div class="show_more_btn" @click="showMore()">SHOW MORE</div>
                </div>
                
            </div>

        </div>

        <CommonH2TitleDescription :title="tags.seo.value.h2_title" :description="tags.seo.value.h2_description" /> 

        <FaqDynamicFaq class="mt-4 pt-4" />
        <CyoPopup v-if="moduleSubType != 'loose'" :module="moduleSubType" />
    </div>
</template>

<script setup>
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    import { useSeo } from '~/composables/seo/setMetaTags';
    
    const store = cyolistStore();
    const route = useRoute();
    const router = useRouter();
    const nuxtApp = useNuxtApp()
    const tags = useSeo();

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType
    const { $choosediamondGtag, $looseImpressionGtag } = useNuxtApp()

    provide('moduleType', moduleType)
    provide('moduleSubType', moduleSubType)


    const togglers = reactive(
                    {
                        viewType: 'grid',
                        advancedFilter:false,
                        
                    })

    const table = ref('result')

    const fAttributes= [
        {
            name:'sort',
            label:'Sort',
            urlLabel:'Sort',
            type:'select_group', 
            displaySelected:true, 
            singleSelect:true,
            default:'price_asc'
        },
        {
            name:'shape',
            label:'shape',
            urlLabel:'Shape',
            type:'select', 
            displaySelected:false, 
            singleSelect:false,
            default:null,
            config:{}
        },
        {
            name:'fiery_round',
            label:'Fiery Round',
            urlLabel:'FieryRound',
            type:'select',
            displaySelected:false,
            singleSelect:true,
            default:null,
            config:{}
        },
        {
            name:'report',
            label:'Report',
            urlLabel:'Report',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:null,
            config:{}
        },
        {
            name:'quickship',
            label:'Quickship',
            urlLabel:'Quickship',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:'yes',
            config:{}
        },
        {
            name:'listview',
            label:'Listview',
            urlLabel:'Listview',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:'yes',
            config:{}
        },
        // {
        //     name:'blockchain',
        //     label:'TRACEABILITY',
        //     urlLabel:'Blockchain',
        //     type:'checkbox', 
        //     displaySelected:false, 
        //     singleSelect:false,
        //     default:'yes',
        //     config:{}
        // },
        {
            name:'price',
            label:'Price',
            urlLabel:'Price',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'num', format:{ notation:'$', position:'prepend' }}
        },
        {
            name:'carat',
            label:'Carat',
            urlLabel:'Carat',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{notation:' ct', position:'append'}}
        },
        {
            name:'depth',
            label:'Depth %',
            urlLabel:'Depth',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{notation:'%', position:'append'}}
        },
        {
            name:'ratio',
            label:'LW Ratio',
            urlLabel:'LWRatio',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{ step:0.01, type: 'num'}
        },
        {
            name:'table',
            label:'Table %',
            urlLabel:'Table',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{ notation:'%', position:'append' }}
        },
        {
            name:'color',
            label:'Color',
            urlLabel:'Color',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'cut',
            label:'Cut',
            urlLabel:'Cut',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'clarity',
            label:'Clarity',
            urlLabel:'Clarity',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'polish',
            label:'Polish',
            urlLabel:'Polish',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'symmetry',
            label:'Symmetry',
            urlLabel:'Symmetry',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'fluorescence',
            label:'Fluorescence',
            urlLabel:'Fluorescence',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        // {
        //     name:'price',
        //     label:'Price',
        //     urlLabel:'Price',
        //     type:'slider', 
        //     displaySelected:true, 
        //     singleSelect:true,
        //     default:null,
        //     options:{}
        // }

    ]
    

    const settings = { moduleType:moduleType, moduleSubType:moduleSubType, filters : fAttributes, page:'diamond' }


    // computed
    const getListviewFilter = computed(() => store.getSettingFilterOptions(moduleSubType, 'listview'))

    const isListviewActive = computed(() => {
        if (getListviewFilter.value) {
            const selectedOption = getListviewFilter.value.find(cv => cv.active === 1)
            return selectedOption !== undefined && selectedOption !== null
        }
        return false
    })


    const resultCount = computed(() => {

        return store.getSettingListingResultCount()
    })   
    const results = computed(() => {
        const item = store.getSettingListingResult()
        if (import.meta.client && item !== null && moduleSubType === 'loose') {
            $looseImpressionGtag(item)
        }
        return item
    })

    const getSettingListingNextPageUrl = computed(() => store.getSettingListingNextPageUrl())

    const showSkeleton = computed(() => store.getSettingShowSkeleton())

    const hasError = computed(() => store.getListingError())

    const displayNoResults = computed(() => {
        return store.getSettingListingCurrentPage() === 1 && results.value.length === 0
    })

    const showMoreSkeleton = computed(() => store.getSkeletonShowMore())
    // computed


    // methods
    const resetFilters = () => {
        window.location = window.location.pathname;
    };

    const toggleFilterVisibility = () => {
    showMobileFilters.value = !showMobileFilters.value;
        if (!showMobileFilters.value) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const mobileFilterBasic = () => {
        filterMobile.value = true;
        props.togglers.advancedFilter = false;
    };

    const mobileFilterAdvance = () => {
        filterMobile.value = false;
        props.togglers.advancedFilter = true;
    };


    const toggleTable = (newTable) => {
        table.value = newTable
    }

    function showMore(){
        store.toggleSettingListingShowMore({ type:moduleSubType} )
        if(moduleSubType === 'loose'){
            $looseImpressionGtag(results.value)
        }
    }
    onMounted(() =>{

        $choosediamondGtag(moduleSubType);


        if( moduleType === 'cyo' ){

            store.validateCyoDiamondCase({ moduleSubType:moduleSubType, filters : fAttributes, page : 'diamond' } )  
        }

        store.setDiamondCompareListCount({moduleSubType:moduleSubType})
    })

    
    
    // start
    const initialPageCallback = async ( asyncData ) => {

        
        if( asyncData  ){

            return await Promise.all( [
                tags.setMetaTags(),
                useAsyncData( route.fullPath , () => store.setupCyoSettingFilter(settings, route, router).then( () => true ))
            ])
        
        }else{

            return await Promise.all( [
                tags.setMetaTags(),
                store.setupCyoSettingFilter(settings, route, router).then( () => true )
            ])
        }

    }

    if( import.meta.client ){
        
        const refreshKeyTwo = computed(() => route.query.RefreshKey);

        // watch works directly on a ref
        watch(refreshKeyTwo, async () => {
            
            console.log('reffesh called', refreshKeyTwo)
            // await refreshNuxtData()
            initialPageCallback()
        })

        // Make RefreshKey reactive using computed
        const refreshKey = computed(() => route.params.start_with);
        // watch works directly on a ref
        watch(refreshKey, async (nv, ov) => {
            if( typeof nv == 'string'  ){
                initialPageCallback()
            }
        })


      
    }
    
    const isHydratedOnServer =  (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered)

    // reset the store on client side page navigations
    if( !isHydratedOnServer ) {

        await store.$reset()
    }   


    usePopstateHandler(async () => {
        initialPageCallback(false)
    });

    if( import.meta.client ){
        // console.log('abcd');
        
        initialPageCallback(true)
    }else{

        await initialPageCallback( true)
    }
    // end
</script>

<style scoped>
.show_more_block {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.show_more_btn {
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    color: #000;
    border: 1px solid #000;
    border-radius: 4px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1.4px;
    text-align: center;
    margin: 0 auto;
    padding: 11px 25px;
    text-transform: uppercase;
    width: 100%;
    /* min-width: 200px; */
    cursor: pointer;
}
.loader{
    display: flex;
    align-items: center;
    justify-content: center;
}
.more_data_box {
        width: fit-content;
    }

    /* .show_more_btn {
        border: 1px solid #000;
        font-size: 14px;
        font-weight: 600;
        margin: 0 auto;
        padding: 11px 25px;
        text-transform: uppercase;
        width: 100%;
        cursor: pointer;
    } */
    .loader_box_mod {
        /* height: 30vh; */
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>